// extracted by mini-css-extract-plugin
module.exports =  {"drawerCarbon":"drawerCarbon_zY1PTtBN","iconButtonContainer":"iconButtonContainer_e1XxSZkv","sidebarContainer":"sidebarContainer_lwcIbDeh"};